import { HtmlReactParser } from "@kaltura/mediaspace-shared-utils";

export interface ToastMessagesProps {
    /**
     * title to display above the messages
     * relevant when messages > 1
     */
    title?: string;
    /** array of messages to display */
    messages: string[];
    /** base className to apply */
    baseClass?: string;
}

/**
 * format an array of toast messages to display
 * for multiple messages, returns an unordered list
 * when the messages array holds a single item,
 * it is returned as-is (wrapped in HtmlReactParser)
 */
export function ToastMessages({ messages, title, baseClass = "kms-ds-toast-messages" }: ToastMessagesProps) {
    if (messages.length === 0) return null;

    if (messages.length === 1) return HtmlReactParser(messages[0]);

    return (
        <>
            {title && <div className={`${baseClass}-title`}>{title}</div>}
            <ul className={`${baseClass}-list`}>
                {messages.map((msg, i) => (
                    <li key={i} className={`${baseClass}-list-item`}>
                        {HtmlReactParser(msg)}
                    </li>
                ))}
            </ul>
        </>
    );
}
